import React from 'react';
import { isAuthenticated } from '../utils/authHelper';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppBar from 'material-ui/AppBar';
import Popover from 'material-ui/Popover';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Menu as MenuIcon } from './Icons';

import BreadCrumb from './BreadCrumb';
import CitySelect from './CitySelect';
import Sidebar from './Sidebar';
import AccountDetailsPopOver from './AccountDetails';
import { updatePassword } from '../utils/PaymentRequestApiUtils';
import userdata from '../config/jwt_token';

const styles = theme => ({
  appBar: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%) !important',
    boxShadow: '0 2px 12px rgba(0,0,0,0.25) !important',
    height: '68px',
  },
  breadcrumbContainer: {
    background: '#ffffff',
    borderBottom: '1px solid #e2e8f0',
    height: 'auto',
    marginTop: '0px',
    padding: '0',
  },
});

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.sidebarRef = React.createRef();
    this.state = {
      header: '',
      open: false,              // profile popover
      change_password_ui: false,
      old_password: '',   old_passwordErr: false,   old_passwordErrText: '',
      new_password: '',   new_passwordErr: false,   new_passwordErrText: '',
      confirm_password:'',confirm_passwordErr:false, confirm_passwordErrText: '',
      dialogBox: false,
      dialogBoxText: '',
    };
  }

  /* ── Account popover ── */
  handleClick = (event) => {
    event.preventDefault();
    this.setState({ open: true, anchorEl: event.currentTarget });
  }
  handleRequestClose = () => { this.setState({ open: false }); }

  /* ── Password change ── */
  handleChange = prop => (event) => {
    this.setState({
      [prop]: event.target.value,
      [prop + 'Err']: false,
      [prop + 'ErrText']: '',
    });
  }
  changePassword() { this.setState({ change_password_ui: true, open: false }); }
  handleClose() {
    this.setState({
      old_password: '', new_password: '', confirm_password: '',
      change_password_ui: false, dialogBox: false,
    });
  }
  handleSubmit() {
    const { old_password, new_password, confirm_password } = this.state;
    if (!old_password) this.setState({ old_passwordErr: true, old_passwordErrText: 'This field is required' });
    if (!new_password) this.setState({ new_passwordErr: true, new_passwordErrText: 'This field is required' });
    if (!confirm_password) this.setState({ confirm_passwordErr: true, confirm_passwordErrText: 'This field is required' });
    if (new_password !== confirm_password) this.setState({ confirm_passwordErr: true, confirm_passwordErrText: 'Passwords do not match' });
    if (old_password && new_password && confirm_password && new_password === confirm_password) {
      updatePassword(JSON.stringify({ old_password, new_password }))
        .then(response => {
          this.setState({
            old_password: '', new_password: '', confirm_password: '',
            dialogBox: true, dialogBoxText: response.message, change_password_ui: false,
          });
        });
    }
  }

  /* ── Sidebar hamburger ── */
  toggleSidebar = () => {
    if (this.sidebarRef && this.sidebarRef.current) {
      this.sidebarRef.current.toggle();
    }
  }

  /* ── Page title from route ── */
  componentWillMount() {
    const pathname = window.location.pathname;
    const titles = {
      '/vendor/onboard': 'Vendor Onboarding',
      '/vendor/approved': 'Verified Vendors',
      '/vendor/approved/info': 'Verified Vendors',
      '/vendor/pending': 'Pending Vendors',
      '/vendor/pending/info': 'Pending Vendors',
      '/vendor/pending/edit': 'Pending Vendors',
      '/home': 'Dashboard',
      '/': 'Login',
      '/vendor/approval-preview': 'Approve Vendors',
      '/vendor/approval': 'Approve Vendors',
      '/payment/request': 'Payment Requests',
      '/vendor/payment/approved': 'Processed Payment Requests',
      '/vendor/payment/approved/preview': 'Processed Payment Requests',
      '/vendor/payment/pending': 'Pending Payment Requests',
      '/vendor/payment/pending/preview': 'Pending Payment Requests',
      '/vendor/payment/approve': 'Approve Payments',
      '/vendor/payment/approve/preview': 'Approve Payments',
      '/vendor/payment/init': 'Payments Initialized',
      '/vendor/payment/success': 'Payment Successful',
      '/vendor/payment/failure': 'Payment Failure',
      '/cost-center/add': 'Add Cost Center',
      '/payment/status': 'Payment Status',
      '/payment/generated_buf': 'Generated BUF',
      '/payment/payment-request-preview': 'Payment Request Preview',
      '/payment/payment-request-preview/timeline': 'Payment Request Timeline',
      '/payment/tally-excel-upload': 'Tally Excel Upload',
      '/cities': 'City Management',
      '/business-units': 'Business Unit Management',
      '/initializePR': 'Payment Request',
      '/bulkPreview': 'Bulk Preview',
      '/payment/reports': 'Reports',
      '/payment/paymentsReport': 'Payments Report',
      '/payment/accountingReport': 'Accounting Report',
      '/payment/billSubmissionReport': 'Bill Submission Report',
      '/payment/provisionReport': 'Provision Report',
      '/payment/costOwnerCenterReport': 'Cost Owner Report',
      '/payment/buf-rejected': 'BUF Rejected Payments',
      '/users': 'User Management',
      '/recoverable-amount-config': 'Recoverable Amount Config',
    };
    const header = titles[pathname] || '';
    this.setState({ header });
  }

  /* ── User initials ── */
  _getInitials() {
    if (!userdata || !userdata.name) return 'U';
    return userdata.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
  }

  render() {
    const { classes } = this.props;
    const isLoggedIn = isAuthenticated();

    return (
      <MuiThemeProvider>
        {/* ── Sidebar (authenticated only) ── */}
        {isLoggedIn && (
          <Sidebar ref={this.sidebarRef} />
        )}

        {/* ── Top AppBar ── */}
        <AppBar
          style={{
            background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)',
            boxShadow: '0 2px 12px rgba(0,0,0,0.28)',
            height: '68px',
          }}
          title={
            <div className="zaps-topbar-content">
              {/* Left: hamburger + title */}
              <div className="zaps-topbar-left">
                {isLoggedIn && (
                  <button className="zaps-hamburger" onClick={this.toggleSidebar} title="Toggle sidebar">
                    <MenuIcon size={18} strokeWidth={2} />
                  </button>
                )}
                <span className="zaps-topbar-title">{this.state.header}</span>
              </div>

              {/* Right: city selector + user avatar */}
              <div className="zaps-topbar-right">
                {isLoggedIn && <CitySelect />}
                {isLoggedIn && (
                  <div
                    className="zaps-user-avatar"
                    onClick={this.handleClick}
                    title="Account"
                  >
                    {this._getInitials()}
                  </div>
                )}
              </div>
              </div>
            // </div>
          }
          className={classes.appBar}
          showMenuIconButton={false}
        />

        {/* ── Profile Popover ── */}
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'right', vertical: 'top' }}
          onRequestClose={this.handleRequestClose}
        >
          <AccountDetailsPopOver changePassword={this.changePassword.bind(this)} />
        </Popover>

        {/* ── Breadcrumb bar ── */}
        <div className={classes.breadcrumbContainer}>
          <BreadCrumb />
        </div>

        {/* ── Change Password Dialog ── */}
        <Dialog
          open={this.state.change_password_ui}
          onClose={this.handleClose.bind(this)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense" label="Old Password" type="password" fullWidth
              onChange={this.handleChange('old_password')}
              error={this.state.old_passwordErr}
              helperText={this.state.old_passwordErrText}
            />
            <TextField
              margin="dense" label="New Password" type="password" fullWidth
              onChange={this.handleChange('new_password')}
              error={this.state.new_passwordErr}
              helperText={this.state.new_passwordErrText}
            />
            <TextField
              margin="dense" label="Confirm New Password" type="password" fullWidth
              onChange={this.handleChange('confirm_password')}
              error={this.state.confirm_passwordErr}
              helperText={this.state.confirm_passwordErrText}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose.bind(this)} color="primary">Cancel</Button>
            <Button onClick={this.handleSubmit.bind(this)} color="primary">Submit</Button>
          </DialogActions>
        </Dialog>

        {/* ── Response Dialog ── */}
        <Dialog
          modal={false}
          open={this.state.dialogBox}
          onClose={this.handleClose.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <h4 style={{ textAlign: 'center' }}>{this.state.dialogBoxText}</h4>
            </DialogContentText>
          </DialogContent>
          <Button primary={true} onClick={this.handleClose.bind(this)}>OK</Button>
        </Dialog>

      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(Header);


// WEBPACK FOOTER //
// ./src/components/Header.js